"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteProfilesService = exports.AuthSuiteProfilesService = void 0;
var profiles_service_1 = require("./profiles-service");
Object.defineProperty(exports, "AuthSuiteProfilesService", { enumerable: true, get: function () { return profiles_service_1.AuthSuiteProfilesService; } });
Object.defineProperty(exports, "authSuiteProfilesService", { enumerable: true, get: function () { return profiles_service_1.authSuiteProfilesService; } });
